import { useRouteError } from "react-router-dom";
import { Footer } from "../contents/Footer";
import { Header } from "../contents/Header";
import { Provider } from "../i18n/useI18n";

export default function ErrorPage() {
  const error: any = useRouteError();

  return (
    <Provider>
      <Header />
      <div id="error-page">
        <h1>Oops!</h1>
        <p>Sorry, an unexpected error has occurred.</p>
        <p>
          <i>{error.statusText || error.message}</i>
        </p>
      </div>

      <Footer />
    </Provider>
  );
}
